module.exports = __webpack_public_path__ + "img/12.2815da14.png";